import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "group relative overflow-hidden" }
const _hoisted_2 = ["autoplay", "loop", "muted", "poster", "controls"]
const _hoisted_3 = ["data-src", "src"]
const _hoisted_4 = ["autoplay", "loop", "muted", "poster", "controls"]
const _hoisted_5 = ["data-src", "src"]
const _hoisted_6 = { class: "center-x bg absolute -bottom-18" }
const _hoisted_7 = { class: "relative whitespace-nowrap text-12 tracking-wider text-white" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazyload = _resolveDirective("lazyload")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.isDeviceMobile)
      ? _withDirectives((_openBlock(), _createElementBlock("video", {
          key: 0,
          ref: "videoPlayer",
          class: _normalizeClass(_ctx.$attrs.class),
          autoplay: $props.autoplay,
          loop: $props.loop,
          muted: $props.muted,
          poster: $props.poster,
          controls: $props.controls,
          preload: "none",
          playsinline: "",
          onLoadedmetadata: _cache[0] || (_cache[0] = (...args) => ($options.handleLoadedMetadata && $options.handleLoadedMetadata(...args)))
        }, [
          _createElementVNode("source", {
            "data-src": $props.sourceMobile,
            src: $props.lazyloaded ? null : $props.sourceMobile,
            type: "video/mp4"
          }, null, 8, _hoisted_3)
        ], 42, _hoisted_2)), [
          [_directive_lazyload, $props.lazyloaded]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("video", {
          key: 1,
          ref: "videoPlayer",
          class: _normalizeClass(_ctx.$attrs.class),
          autoplay: $props.autoplay,
          loop: $props.loop,
          muted: $props.muted,
          poster: $props.poster,
          controls: $props.controls,
          preload: "none",
          playsinline: "",
          onLoadedmetadata: _cache[1] || (_cache[1] = (...args) => ($options.handleLoadedMetadata && $options.handleLoadedMetadata(...args)))
        }, [
          _createElementVNode("source", {
            "data-src": $props.source,
            src: $props.lazyloaded ? null : $props.source,
            type: "video/mp4"
          }, null, 8, _hoisted_5)
        ], 42, _hoisted_4)), [
          [_directive_lazyload, $props.lazyloaded]
        ]),
    ($props.controls && $props.timestamps)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($data.timestampsData, (timestamp, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: timestamp.title,
            class: "pointer-events-none absolute bottom-[0.9rem] h-14 w-14 rounded-circle border bg-white opacity-0 shadow transition-opacity duration-300 group-hover:opacity-100",
            style: _normalizeStyle({
          left: timestamp.position,
          'margin-left': index === 0 && '1rem',
          'margin-right': index === $props.timestamps.length - 1 && '1rem',
        })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(timestamp.title), 1)
            ])
          ], 4))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}